// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TitV","importantInfo":"styles_importantInfo__2GRJR"};